<template>
  <div>
    <!-- 顶部 -->
    <detailHeader />
    <div class="content">
      <!--群发信息  -->
      <h1>{{ $t("message.massMessaging") }}</h1>
      <el-form :model="datas" :rules="rules" ref="datas" label-width="150px" class="demo-ruleForm">
        <!-- 通告群体： -->
        <el-form-item :label="$t('message.noticeGroup') + ':'" prop="type">
          <el-select v-model="datas.type" placeholder="请选择" @change="changeNange">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"
              :disabled="item.disabled">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 人员选择 -->
        <el-form-item :label="$t('message.personnelSelection') + ':'" v-if="datas.type == '部分客户'">
          <div class="value">
            <div class="button">
              <!-- 选择 -->
              <el-button type="primary" class="primary" @click="choose">
                {{ $t("message.choose") }}
              </el-button>
            </div>
            <!-- 部分客户 -->
            <div class="table" v-if="datas.type == '部分客户'">
              <el-table :data="selectedPersonnel" :default-sort="{ prop: 'date', order: 'descending' }"
                :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" max-height="400px">
                <el-table-column align="center" type="index" width="80" label="NO">
                </el-table-column>
                <!-- 客户ID -->
                <el-table-column align="center" :label="$t('message.clientID')" prop="id">
                </el-table-column>
                <!-- 客户名称 -->
                <el-table-column align="center" :label="$t('message.userName')" prop="realname">
                </el-table-column>
                <!-- 删除 -->
                <el-table-column :label="$t('message.delete')" align="center">
                  <template slot-scope="scope">
                    <el-button size="mini" type="danger" @click="delSelectedPersonnel(scope.row.id)">
                      {{ $t("message.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>

          </div>
        </el-form-item>
        <!-- 邮件标题 -->
        <el-form-item :label="$t('message.mailTitle') + ':'" prop="title">
          <el-input v-model="datas.title"></el-input>
        </el-form-item>
        <!-- 发送时间 -->
        <el-form-item :label="$t('message.sendTime') + ':'" prop="send_at" placeholder="请选择">
          <el-date-picker v-model="datas.send_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择发送时间" />
        </el-form-item>
        <!-- 消息内容 -->
        <el-form-item :label="$t('message.messageContent') + ':'" prop="contentText">
          <el-input type="textarea" v-model="datas.contentText"></el-input>
        </el-form-item>
      </el-form>
      <!-- 预览 -->
      <div class="btn">
        <!-- 保存 -->
        <el-button type="primary" @click="EmailPusPush">
          {{ $t("message.save") }}
        </el-button>
        <!--预览 -->
        <el-button type="success" @click="preview">
          {{ $t("message.preview") }}
        </el-button>
      </div>
    </div>
    <!-- 人员选择 -->
    <el-dialog :title="$t('message.personnelSelection')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="800px" center>
      <div class="body">
        <div class="search">
          <!-- 客户ID： -->
          <div class="label">
            {{ $t("message.clientID") }}:
          </div>
          <!--搜索  -->
          <div class="value">
            <el-input v-model="personnelData.searchText" onfocus="this.select()" clearable></el-input>
          </div>

          <!-- 查询 -->
          <div class="label" style="width: 60px;">
            <el-button type="primary" @click="getAccountInfo">
              {{ $t("message.inquire") }}
            </el-button>
          </div>
        </div>
        <el-table :data="user_id_set" border :header-cell-style="{ background: '#EDEFF4' }" max-height="500px">
          <!-- 客户ID -->
          <el-table-column prop="id" :label="$t('message.clientID')" align="center">
          </el-table-column>
          <!--客户名称-->
          <el-table-column prop="realname" :label="$t('message.customerName')" align="center">
          </el-table-column>
          <!-- 删除 -->
          <el-table-column align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="delItem(scope.row.id)">
                {{ $t("message.delete") }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 全部客户发送验证 -->
    <el-dialog title="全部客户发送验证" :close-on-click-modal="false" :visible.sync="allCustomerConfirmVisible" width="500px"
      center @closed="allCustomerConfirmText = ''">
      <div class="all-customer-confirm" @copy.prevent @cut.prevent @paste.prevent>
        <div class="confirm-tip">
          <p>重要操作：通知将发送给【全部客户】
            此操作无法撤销，请务必确认发送范围。</p>
          如需继续，请手动输入<span>“全部客户”</span>
        </div>
        <el-input v-model.trim="allCustomerConfirmText" placeholder="请输入全部客户" autocomplete="off"
          @paste.native.prevent="handleAllCustomerPaste" @copy.native.prevent @cut.native.prevent>
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="allCustomerConfirmVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <el-button type="primary" :disabled="allCustomerConfirmText !== '全部客户'" @click="confirmAllCustomerSend">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 预览 -->
    <preview ref="preview" />
  </div>
</template>
<script>
import detailHeader from "@/components/header/detailHeader";
import preview from './preview'
export default {
  components: {
    detailHeader,
    preview,
  },
  data() {
    return {
      userId: (JSON.parse(localStorage.getItem('japanUserRoleInfo')).id + ''), //
      datas: {
        title: '',
        contentText: "",
        type: "", //10-全部客户,11-部分客户,20-全部管理员,21-部分管理员
        user_id_set: [],
      },
      rules: {
        title: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        contentText: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
      },

      //   人员选择
      dialogVisible: false,
      selectedPersonnel: [],
      user_id_set: [],
      personnelData: {
        searchText: "",
        section: "",
        type: 'user',
      },
      //
      content: '',
      allCustomerConfirmVisible: false,
      allCustomerConfirmText: '',

    };
  },
  computed: {
    options() {
      return [
        {
          label: "全部客户",
          value: "全部客户",
          disabled: this.userId != 13
        },
        {
          label: "部分客户",
          value: "部分客户",

        },

      ]
    },
  },
  created() {
  },
  methods: {

    //状态筛选
    changeNange(e) {
      this.selectedPersonnel = [];
    },
    // 选择
    choose() {
      this.user_id_set = [];
      this.personnelData.searchText = "";
      this.personnelData.section = "";
      this.dialogVisible = true;
    },
    //人员搜索
    getAccountInfo() {
      this.$api.siteConfiguration
        .getAccountInfo(this.personnelData)
        .then((res) => {
          if (res.data == false) {
            return this.$message.error("未匹配此ID");
          }
          this.user_id_set = [... this.user_id_set, ...res.data.batch]
          var hash = {};
          this.user_id_set = this.user_id_set.reduce(function (item, next) {
            hash[next.id]
              ? ""
              : (hash[next.id] = true && item.push(next));
            return item;
          }, []);
        });
    },
    // 删除未选择人员
    delItem(id) {
      let index = this.user_id_set.findIndex((item) => item.id == id);
      this.user_id_set.splice(index, 1);
    },
    //删除已选择的
    delSelectedPersonnel(id) {
      let index = this.selectedPersonnel.findIndex((item) => item.id == id);
      this.selectedPersonnel.splice(index, 1);
    },
    //人员保存
    save() {
      this.selectedPersonnel = [...this.selectedPersonnel, ...this.user_id_set];
      this.dialogVisible = false;
    },
    //群发消息模版添加
    EmailPusPush() {

      this.$refs.datas.validate((valid) => {
        if (valid) {
          this.datas.user_id_set = this.selectedPersonnel.map(item => item.id)
          if (this.datas.type === '全部客户') {
            this.allCustomerConfirmText = ''
            this.allCustomerConfirmVisible = true
            return
          }
          this.confirmEmailSend()
        }
      });
    },
    handleAllCustomerPaste() {
      this.$message.warning('请手动输入全部客户')
    },
    confirmAllCustomerSend() {
      if (this.allCustomerConfirmText !== '全部客户') {
        this.$message.error('请输入全部客户')
        return
      }
      this.allCustomerConfirmVisible = false
      this.confirmEmailSend()
    },
    confirmEmailSend() {
      this.$confirm(
        '请再次确认是否发送邮件，邮件一经发送无法取消',
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          this.datas.content = this.emailContent()
          this.$api.noticeApi.EmailPusPush(this.datas).then((res) => {
            this.$message.success(res.msg);
            this.$router.push("/menu3_config_notice?activeName=4");
          });
        })
        .catch(() => { });
    },
    //预览
    preview() {
      this.$refs.preview.content = this.emailContent()
      this.$refs.preview.dialogVisible = true
    },
    emailContent() {
      return `
     <!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Document</title>
  </head>
  <body style="margin: 0; padding: 0; font-size: 16px">
    <div style="min-width: 680px; max-width: 680px; margin: 0 auto">
      <!-- 头部部分 -->
      <div class="header">
        <!-- banner -->
        <div
          class="containerHeader"
          style="
            background: url('https://rakumart-ps20.oss-ap-northeast-1.aliyuncs.com/202306/64915a0bbd2b3.png');
            background-repeat: no-repeat;
            background-position: center;
            background-size: 100% 100%;
            width: 100%;
            height: 258px;
            padding: 10px 6px;
            box-sizing: border-box;
          "
        >
          <!-- 信封上边 -->
          <img
            src="https://rakumart-ps20.oss-ap-northeast-1.aliyuncs.com/202306/649159fc64060.png"
            alt=""
            style="width: 100%"
          />
          <!-- logo -->
          <div class="logo" style="text-align: center; margin-top: 53px">
            <img
              src="https://rakumart-ps20.oss-ap-northeast-1.aliyuncs.com/202306/649159cf526f0.png"
              alt=""
              style="width: 150px; height: 96px"
            />
          </div>
        </div>
        <!-- 企业介绍 -->
        <div
          class="intro"
          style="border-bottom: 1px dashed #e9ecf0; margin: 30px"
        >
          <div
            class="introHeader"
            style="font-size: 20px; font-weight: 600; color: #000; margin: 30px 0;"
          >
           ${this.datas.title}
          </div>
         
        </div>
      </div>

      <!-- 主体部分 -->
      <div
        class="section"
        style="
          margin: 0 30px;
          box-sizing: border-box;
          border-bottom: 1px dashed #e9ecf0;
          font-size: 16px;
          font-weight: 400;
          color: #000;
          line-height: 22px;
        "
      >
        ${this.datas.contentText}
      </div>
      <!-- 底部 -->
      <div class="bottom" style="margin-bottom: 10px">
        <div
          class="addressLink"
          style="margin: 30px 30px; border-bottom: 1px dashed #e9ecf0"
        >
          <div style="font-size: 20px; font-weight: 600; color: #000">
          RAKUMART 株式会社
          </div>
          <div style="font-size: 16px; margin: 18px 0 28px 0">
           ホームページ:
            <a href="https://www.rakumart.com">https://www.rakumart.com</a>
          </div>
        </div>
        <div style="font-size: 20px; margin: 0 30px; font-weight: 600">
        メールによるお問い合わせ
        </div>
        <div
          style="
            font-size: 16px;
            font-weight: 400;
            line-height: 22px;
            margin: 18px 30px 0 30px;
          "
        >
          <a href="services@rakumart.com">services@rakumart.com</a><br />
         24時間対応致します。<br />
         受付時間：平日 10:00 - 18:30（土、日曜日、当社指定休日は休み）
        </div>
        <div
          style="font-size: 20px; font-weight: 600; margin: 30px 30px 0 30px"
        >
         お電話によるお問い合わせ
        </div>
        <div
          style="
            font-size: 16px;
            font-weight: 400;
            line-height: 22px;
            margin: 18px 30px 0 30px;
          "
        >
          日本本社<br />
         〒556-0011 大阪府大阪市浪速区難波中１丁目３−１８ＤＡＩＩＣＨＩ大阪ビル 8階<br />
         TEL:06-7636-8120<br />
          受付時間：平日 9:30 - 17:00（土、日曜日、当社指定休日は休み）
        </div>
        <div
          style="
            font-size: 16px;
            font-weight: 400;
            line-height: 22px;
            margin: 18px 30px 30px 30px;
          "
        >
          中国義烏本社<br />
         〒322-000<br />
         浙江省金華市義烏市北苑街道景三道35号2号<br />
         受付時間：平日 9:30 - 18:30（土、日曜日、当社指定休日は休み）
        </div>
        <img
          src="https://rakumart-ps20.oss-ap-northeast-1.aliyuncs.com/202306/64915a1f35c03.png"
          alt=""
          style="width: 100%"
        />
      </div>
    </div>
  </body>
</html>

      `
    },
  },
};
</script>
<style lang='scss' scoped>
h1 {
  font-size: 25px;
  font-weight: 600;
  margin: 0 0 40px;
  text-align: center;
}

.content {
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  padding: 24px;
  margin: 24px;
  min-width: 1814px;

  .value {
    flex: 1;
    display: flex;

    .button {
      width: 100px;
      margin-right: 40px;
    }

    .table {
      width: 500px;
    }
  }

  /deep/.el-form-item__label {
    font-size: 20px;
  }

  /deep/.el-textarea__inner {
    height: 100px;
  }
}

/deep/.el-textarea__inner {
  min-height: 300px !important;
}

.search {
  display: flex;
  margin-bottom: 20px;
  line-height: 40px;

  .label {
    width: 120px;
    text-align: right;
  }

  .value {
    flex: 1;
    margin: 0 30px;
  }
}

.btn {
  text-align: center;
}

.all-customer-confirm {
  padding: 0 20px;

  .confirm-tip {
    margin-bottom: 20px;
    color: #606266;
    font-size: 20px;

    p {
      margin-bottom: 20px;
    }

    span {
      color: red;
    }
  }
}

/deep/.el-upload {
  border: none;
}

/deep/.el-upload-dragger {
  width: 120px !important;
  height: 120px !important;
}
</style>
